import React from 'react';
import colorTypeHelper from 'utils/colorTypeHelper';
import InPageFeaturesV4 from './InPageFeaturesV4';
import InPageFeaturesV3 from './InPageFeaturesV3';
import InPageFeaturesV2 from './InPageFeaturesV2';
import InPageFeaturesV1 from './InPageFeaturesV1';

const ContentfulInPageFeatures = props => {
  const { useV2Styling, useV3Styling, useV4Styling, description, bgColor, index } = props || {};

  if (useV2Styling) {
    return (
      <InPageFeaturesV2
        {...props}
        description={description?.description || ''}
        backgroundColor={colorTypeHelper[bgColor]}
      />
    );
  }
  if (useV3Styling) {
    return <InPageFeaturesV3 {...props} index={index} />;
  }
  if (useV4Styling) {
    return <InPageFeaturesV4 {...props} />;
  }
  return (
    <InPageFeaturesV1
      {...props}
      description={description?.description || ''}
      backgroundColor={colorTypeHelper[bgColor]}
    />
  );
};

export default ContentfulInPageFeatures;
